import React from "react";
import { Link, useNavigate } from "react-router-dom";
import RevokeRequest from "./RevokeRequest";

const RevokeRequestList = () => {
  return (
    <section id="content" className="content">
      <div className="content__header content__boxed overlapping">
        <div className="content__wrap">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item">Policy</li>
              <li className="breadcrumb-item active" aria-current="page">
                Revocation
              </li>
            </ol>
          </nav>

          <h1 className="page-title mb-0 mt-2">Revocation Request List</h1>

          <p className="lead">View all policy revocation requests</p>
        </div>
      </div>

      <div className="content__boxed">
        <div className="content__wrap">
          <div className="tab-base1">
            <ul className="nav nav-tabs mb-2" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  //onClick={() => navigate("/commissions/deferred/pending")}
                  className="nav-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#_dm-tabsPending"
                  type="button"
                  role="tab"
                  aria-controls="pending"
                  aria-selected="true"
                >
                  <Link
                    to="/policies/revoke-requests/pending"
                    className="btn-link"
                  >
                    Pending
                  </Link>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#_dm-tabsDecline"
                  type="button"
                  role="tab"
                  aria-controls="decline"
                  aria-selected="false"
                >
                  <Link
                    to="/policies/revoke-requests/declined"
                    className="btn-link"
                  >
                    Declined
                  </Link>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#_dm-tabsAll"
                  type="button"
                  role="tab"
                  aria-controls="all"
                  aria-selected="false"
                >
                  <Link
                    to="/policies/revoke-requests/approved"
                    className="btn-link"
                  >
                    Approved
                  </Link>
                </button>
              </li>
            </ul>

            <div className="tab-content">
              <div
                id="_dm-tabsPending"
                className="tab-pane fade active show"
                role="tabpanel"
                aria-labelledby="pending-tab"
              >
                <RevokeRequest />
              </div>
              <div
                id="_dm-tabsDecline"
                className="tab-pane fade"
                role="tabpanel"
                aria-labelledby="decline-tab"
              >
                <RevokeRequest />
              </div>
              <div
                id="_dm-tabsAll"
                className="tab-pane fade"
                role="tabpanel"
                aria-labelledby="all-tab"
              >
                <RevokeRequest />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RevokeRequestList;
